import { Carousel } from "react-responsive-carousel";
import { NavLink } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function HeroCarousel() {
  return (
    <Carousel
      autoPlay={true}
      showThumbs={false}
      infiniteLoop={true}
      dynamicHeight={false}
      showStatus={false}
    >
      <div className="relative">
        <div
          className="relative w-full bg-center bg-contain aspect-[768/950] md:aspect-[1438/516] 
      md:bg-[url('https://sale.ford.bg/images/puma-gen-e/puma-gen-e-desktop-slide.jpg')] 
      bg-[url('https://sale.ford.bg/images/puma-gen-e/puma-gen-e-mobile-slide.jpg')]"
        >
          <div className="absolute inset-0 z-0 bg-gradient-to-b from-black/30 to-transparent" />
          <h2 className="absolute z-10 w-full px-2 text-2xl text-center text-white transform -translate-x-1/2 font-fordBlack top-12 left-1/2 md:text-left md:text-4xl md:top-6 md:left-6 md:bottom-auto md:transform-none">
            Новата изцяло електрическа Puma Gen-E
          </h2>
          <p className="absolute z-10 w-full px-2 text-center text-white transform -translate-x-1/2 font-fordMedium bottom-24 left-1/2 md:text-left md:text-lg md:top-20 md:left-6 md:bottom-auto md:transform-none">
            Сега на невероятна цена от 57 700лв. с ДДС
          </p>
          <a
            href="/landing/puma-gen-e"
            className="absolute z-10 bottom-[10%] left-1/2 transform -translate-x-1/2"
          >
            <button className="px-4 py-2 text-sm tracking-wider text-white uppercase border bg-fordBlue btn-primary border-fordBlue hover:bg-white hover:text-fordBlue">
              Научете повече
            </button>
          </a>
        </div>
      </div>
      <div className="relative">
        <div
          className="relative w-full bg-center bg-contain aspect-[768/950]  md:aspect-[1438/516] 
                md:bg-[url('https://sale.ford.bg/images/puma-gen-e-desktop-vignette.jpg')] 
                bg-[url('https://sale.ford.bg/images/puma-gen-e-mobile.jpg')]"
        >
          <h2 className="absolute text-2xl text-center md:text-left text-white tracking-wider ml-6 md:ml-2 md:left-8 font-fordMedium  top-[60%] md:top-[12%]">
            Избери своя FORD PUMA<sup>®</sup>
          </h2>
          <div className="absolute flex flex-wrap flex-col md:flex-row  md:justify-start w-full gap-2 transform top-[70%] md:top-[21%] md:left-8">
            <a
              href="https://ford.bg/cars/puma-gen-e"
              rel="noreferrer"
              target="_blank"
            >
              <button className="px-4 py-2 text-xs tracking-widest text-white uppercase border bg-fordBlue btn-primary border-fordBlue hover:bg-white hover:text-fordBlue">
                Електрически модел
              </button>
            </a>
            <a
              href="https://ford.bg/cars/new-puma"
              rel="noreferrer"
              target="_blank"
            >
              <button className="px-4 py-2 text-xs tracking-widest text-white uppercase border bg-fordBlue btn-primary border-fordBlue hover:bg-white hover:text-fordBlue">
                Хибриден модел
              </button>
            </a>
          </div>
        </div>
      </div>
      <div>
        <div
          className="relative w-full bg-center bg-contain aspect-[768/950] md:aspect-[1438/516] 
                md:bg-[url('https://sale.ford.bg/images/electric-explorer-free-charging/explorer.jpg')] 
                bg-[url('https://sale.ford.bg/images/electric-explorer-free-charging/explorer-mobile.jpg')]"
        >
          <p className="absolute w-full text-3xl text-center text-white transform -translate-x-1/2 font-fordBlack left-1/2 drop-shadow-md top-[10%] md:top-[15%]">
            НОВИЯТ ИЗЦЯЛО ЕЛЕКТРИЧЕСКИ FORD EXPLORER{" "}
            <span className="text-sm align-super">®</span>
          </p>
          <a
            href="https://ford.bg/cars/new-explorer"
            rel="noreferrer"
            target="_blank"
          >
            <button className="absolute bottom-[16%] md:bottom-[12%] transform -translate-x-1/2 left-1/2 px-4 py-2 text-sm tracking-wider text-white border bg-fordBlue btn-primary border-fordBlue hover:bg-white hover:text-fordBlue">
              НАУЧЕТЕ ПОВЕЧЕ
            </button>
          </a>
        </div>
      </div>
    </Carousel>
  );
}
